import { useQuery } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { listMcpConnectorPresets } from '@/services/mcp-gateway';
import type { McpConnectorPreset } from '@/services/mcp-gateway';

export function useMcpConnectorPresets() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery<McpConnectorPreset[]>({
    queryKey: ['mcp-connector-presets', orgId],
    queryFn: () => listMcpConnectorPresets(orgId),
    enabled: !!orgId,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
